import { useState } from 'react';
import { api } from '../api';
import { useAuth } from './AuthProvider';

/**
 * Своего входа у дэшборда нет. Кнопка уводит на существующий вход основного
 * приложения; бэкенд возвращает браузер обратно с токеном в адресе.
 */
export default function LoginPage({ deniedFor }) {
  const { signOut } = useAuth();
  const [busy, setBusy] = useState(false);

  return (
    <section id="login">
      <div className="login-card">
        <div className="login-logo">
          <span className="dsp">7</span><span className="spark">✦</span><span className="dsp">CUT</span>
          <span className="tag">админка</span>
        </div>

        {deniedFor ? (
          <>
            <h1>доступа нет</h1>
            <p>
              Вы вошли как <span className="mono">{deniedFor}</span>, но у этой учётной записи
              нет прав администратора. Доступ выдаётся глобальной ролью — попросите того,
              кто уже в админке, назначить её.
            </p>
            <button className="btn-primary" onClick={signOut}>войти другим аккаунтом</button>
          </>
        ) : (
          <>
            <h1>вход</h1>
            <p>Тот же вход, что и в 7cut. Внутрь пускает роль администратора.</p>
            <button
              className="btn-primary"
              disabled={busy}
              onClick={() => { setBusy(true); api.auth.login(); }}
            >
              {busy ? 'переходим…' : 'войти через 7cut'}
            </button>
            <div className="login-hint">
              Если аккаунта ещё нет, сначала зарегистрируйтесь в основном приложении —
              админка использует ту же учётную запись.
            </div>
          </>
        )}
      </div>
    </section>
  );
}
